import React, { useState, useEffect, useImperativeHandle, forwardRef } from "react";
import { Col, Row } from "reactstrap";


const ProfessionalExperience = forwardRef(({ applicationId, onNext, onSave, data, onDataChange, resumeData }, ref) => {
  const [formData, setFormData] = useState({
    organisation_name: '',
    designation: '',
    responsibilities: ''
  });
  const [errors, setErrors] = useState({});
  const [showValidation, setShowValidation] = useState(false);

  console.log("Received resumeData in ProfessionalExperience:", resumeData);

  // Initialize form data from parent when data prop changes
  useEffect(() => {
    if (data) {
      setFormData(prev => ({
        ...prev,
        organisation_name: data.organisation_name || '',
        designation: data.designation || '',
        responsibilities: data.responsibilities || ''
      }));
    }
  }, [data]);

  useEffect(() => {
    if (resumeData?.professionalExperience?.[0]) {
      setFormData(prev => ({
        ...prev,
        organisation_name: resumeData.professionalExperience[0].organisation || '',
        designation: resumeData.professionalExperience[0].designation || '',
        responsibilities: resumeData.professionalExperience[0].responsibilities || ''
      }));
    }
  }, [resumeData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    // Convert null/undefined values to empty strings to prevent backend validation errors
    const sanitizedValue = value ?? "";
    const updatedData = {
      ...formData,
      [name]: sanitizedValue,
    };
    setFormData(updatedData);
    if (onDataChange) {
      onDataChange(updatedData);
    }
  };

  // Validation function
  const validate = () => {
    const newErrors = {};
    if (!formData?.organisation_name?.trim()) newErrors.organisation_name = "Organization Name is required";
    if (!formData?.designation?.trim()) newErrors.designation = "Designation is required";
    if (!formData?.responsibilities?.trim()) newErrors.responsibilities = "Roles & Responsibilities are required";
    setErrors(newErrors);
    setShowValidation(true);
    return Object.keys(newErrors).length === 0;
  };

  useImperativeHandle(ref, () => ({
          validate,
          getFormData: () => formData
      }));


  return (
    <>
      <Row>
        <Col xl="12">
          <h2 className="personalinfo_head">Professional Experience</h2>
        </Col>
      </Row>

      <Row>
        <Col xl="6">
          <div className="personal_formdetail">
            <h5>Current / Last Organization Name <span>*</span></h5>
            <input
              type="text"
              className={`form-control form_custom${showValidation && errors.organisation_name ? ' is-invalid' : ''}`}
              name="organisation_name"
              value={formData.organisation_name || ''}
              onChange={handleChange}
              placeholder="Please provide the name of your organization"
            />
            {showValidation && errors.organisation_name && (
              <div className="invalid-feedback d-block">{errors.organisation_name}</div>
            )}
          </div>
        </Col>

        <Col xl="6">
          <div className="personal_formdetail">
            <h5>Designation <span>*</span></h5>
            <input
              type="text"
              className={`form-control form_custom${showValidation && errors.designation ? ' is-invalid' : ''}`}
              name="designation"
              value={formData.designation || ''}
              onChange={handleChange}
              placeholder="Description of designation"
            />
            {showValidation && errors.designation && (
              <div className="invalid-feedback d-block">{errors.designation}</div>
            )}
          </div>
        </Col>
      </Row>

      <Row>
        <Col xl="12">
          <div className="personal_formdetail">
            <h5>Roles & Responsibilities <span>*</span></h5>
            <textarea
              className={`form-control text_custom${showValidation && errors.responsibilities ? ' is-invalid' : ''}`}
              name="responsibilities"
              value={formData.responsibilities || ''}
              onChange={handleChange}
              placeholder="Description of Roles & Responsibilities"
            ></textarea>
            {showValidation && errors.responsibilities && (
              <div className="invalid-feedback d-block">{errors.responsibilities}</div>
            )}
          </div>
        </Col>
      </Row>
    </>
  );
});

export default ProfessionalExperience;
